import React, { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Bell, Send, Mail, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import api from '../api/client';
import toast from 'react-hot-toast';

export default function NotificationsPage() {
  const qc = useQueryClient();
  const [sending, setSending] = useState(false);

  const { data } = useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get('/notifications'),
  } as any);

  const notifications = (data as any)?.data?.notifications || [];

  const sendOverdue = async () => {
    setSending(true);
    try {
      const { data: res } = await api.post('/notifications/send-overdue');
      toast.success(`${(res as any).sent} შეტყობინება გაიგზავნა`);
      qc.invalidateQueries({ queryKey: ['notifications'] });
    } catch { toast.error('შეცდომა'); }
    finally { setSending(false); }
  };

  return (
    <div style={{padding:24,fontFamily:'system-ui,sans-serif'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
        <div>
          <h1 style={{fontSize:20,fontWeight:600,color:'var(--text-primary)',margin:0}}>შეტყობინებები</h1>
          <p style={{fontSize:12,color:'var(--text-faint)',marginTop:4}}>ელ-ფოსტის გაგზავნა და ისტორია</p>
        </div>
        <button onClick={sendOverdue} disabled={sending}
          style={{display:'flex',alignItems:'center',gap:6,padding:'8px 16px',background:'#dc2626',border:'none',borderRadius:8,color:'white',fontSize:12,fontWeight:500,cursor:'pointer',opacity:sending?0.6:1}}>
          <AlertTriangle size={14} /> {sending ? 'იგზავნება...' : 'ვადაგადაც. შეხსენება'}
        </button>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12,marginBottom:20}}>
        {[
          {label:'სულ გაგზავნილი', val:notifications.filter((n:any)=>n.status==='sent').length, color:'var(--success)', icon:CheckCircle},
          {label:'ვადაგადაცილებული', val:notifications.filter((n:any)=>n.type==='overdue').length, color:'var(--danger)', icon:AlertTriangle},
          {label:'წარუმატებელი', val:notifications.filter((n:any)=>n.status==='failed').length, color:'var(--warning)', icon:XCircle},
        ].map(s => (
          <div key={s.label} style={{background:'var(--bg-card)',border:'1px solid #1e2d45',borderRadius:12,padding:16,display:'flex',alignItems:'center',gap:12}}>
            <s.icon size={24} style={{color:s.color,flexShrink:0}} />
            <div>
              <div style={{fontSize:11,color:'var(--text-faint)'}}>{s.label}</div>
              <div style={{fontSize:22,fontWeight:700,color:s.color}}>{s.val}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{background:'var(--bg-card)',border:'1px solid #1e2d45',borderRadius:12,overflow:'hidden'}}>
        <div style={{padding:'14px 16px',borderBottom:'1px solid #1e2d45',display:'flex',alignItems:'center',gap:8,fontSize:13,fontWeight:500,color:'var(--text-secondary)'}}>
          <Bell size={15} />
          შეტყობინებების ისტორია
        </div>
        {notifications.length === 0
          ? <p style={{padding:32,textAlign:'center',color:'var(--text-dimmed)',fontSize:13}}>შეტყობინება არ არის</p>
          : notifications.map((n: any) => (
            <div key={n.id} style={{display:'flex',alignItems:'center',gap:12,padding:'12px 16px',borderBottom:'1px solid #0f1826'}}>
              <div style={{width:32,height:32,borderRadius:8,
                background:n.status==='sent'?'var(--success-bg)':n.status==='failed'?'var(--danger-bg)':'var(--warning-bg)',
                display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <Mail size={15} style={{color:n.status==='sent'?'var(--success)':n.status==='failed'?'var(--danger)':'var(--warning)'}} />
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:13,color:'var(--text-secondary)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{n.subject}</div>
                <div style={{fontSize:11,color:'var(--text-faint)',marginTop:2}}>
                  {n.channel?.toUpperCase()} · {n.type} · {n.sent_at ? new Date(n.sent_at).toLocaleString() : '—'}
                </div>
              </div>
              <span style={{padding:'2px 8px',borderRadius:6,fontSize:11,fontWeight:500,flexShrink:0,
                background:n.status==='sent'?'var(--success-bg)':n.status==='failed'?'var(--danger-bg)':'var(--bg-dark2)',
                color:n.status==='sent'?'var(--success)':n.status==='failed'?'var(--danger)':'var(--text-muted)'}}>
                {n.status==='sent'?'გაგზავნილი':n.status==='failed'?'წარუმატებელი':'pending'}
              </span>
            </div>
          ))
        }
      </div>
    </div>
  );
}
